import React from 'react';
import { useTranslation } from "react-i18next";
import { ReactComponent as Android } from "./assets/android.svg";
import { ReactComponent as Arrowdown } from "./assets/arrow_down.svg";
import { ReactComponent as Bottombg } from "./assets/bottom-bg.svg";
import { ReactComponent as Checked } from "./assets/checked.svg";
import { ReactComponent as Down } from "./assets/down.svg";
import { ReactComponent as Icon } from "./assets/download_icon_3.svg";
import file1 from "./assets/file1.png";
import file2 from "./assets/file2.png";
import file3 from "./assets/file3.png";
import file4 from "./assets/file4.png";
import file5 from "./assets/file5.png";
import file6 from "./assets/file6.png";
import Icontop from "./assets/icon_top_2.svg";
import { ReactComponent as Ios } from "./assets/ios.svg";
import { ReactComponent as Mac } from "./assets/mac.svg";
import { ReactComponent as Window } from "./assets/window.svg";

import "./download.scss";

export const Download = () => {
  const { t } = useTranslation()
  const list = [
    "适用于Windows、MacOS、安卓、 iOS等系统",
    "全天候客户支持",
    "创建AI助理，即时解答用户问题",
    "支持桌面端、移动端消息共享，独特的加密保障数据安全。",
  ];
  const locationHandler = (href) => { 
    window.location.href = href;
  }
  return (
    <div className="download-container">
      <div className="download-top">
        {/* <div className="download-top-icon">
          <Icon />
          <div>AleIM</div>
        </div> */}
        {/* <video controls width="640" height="360">
          <source src={downShare} type="video/mp4" />
          Your browser does not support the video tag.
        </video> */}
        <div className="download-logo-icon">
          <div className="iconShow-container">
            <img src={Icontop} className="iconShow" />
          </div>
          <p className="download-logo-text">AleIM</p>
        </div>
        <div className="download-top-bottom">
          {t(
            "是一款以全新设计理念，致力于保证通信数据安全而打造的加密聊天工具，帮助用户降低沟通成本，提升沟通效率。"
          )}
        </div>
        <legend>{t("兼容")}</legend>
        <div className="list-icon">
          <div>
            <Android
              onClick={() =>
                locationHandler(
                  "https://edge2.oss-ap-southeast-1.aliyuncs.com/app-release-1.0.7.apk"
                )
              }
            />
            <div>Android</div>
          </div>
          <div>
            <Ios
              onClick={() =>
                locationHandler(
                  "https://apps.apple.com/us/app/aleim/id6450179044"
                )
              }
            />
            <div>iOS</div>
          </div>
          <div>
            <Window
              onClick={() =>
                locationHandler(
                  "https://edge2.oss-ap-southeast-1.aliyuncs.com/Aleim-v1.0.7-win-x64.exe"
                )
              }
            />
            <div>Windows</div>
          </div>
          <div>
            <Mac
              onClick={() =>
                locationHandler(
                  "https://edge2.oss-ap-southeast-1.aliyuncs.com/Aleim-v1.0.7-mac-arm64.dmg"
                )
              }
            />
            <div>Mac OS</div>
          </div>
          <div>
            <Mac
              onClick={() =>
                locationHandler(
                  "https://edge2.oss-ap-southeast-1.aliyuncs.com/Aleim-v1.0.7-mac-x64.dmg"
                )
              }
            />
            <div>Intel</div>
          </div>
        </div>
        <div className="arrow-down-download">
          <Arrowdown />
        </div>
      </div>
      <div className="download-bottom" id="download-bottom">
        <div className="arrow-left">
          <Down />
        </div>
        <div className="private-deployment">
          <div className="private-deployment-top">
            <div className="private-deployment-top-left">
              {t("选择私有化部署")}
              <div className="private-deployment-top-left-bg"></div>
            </div>
            <div className="private-deployment-top-right">
              <img src={file1} className="file1" />
            </div>
          </div>
          <div className="private-deployment-content">
            {t(
              "数据安全是至关重要的。他们不想把数据放在公共服务器上，而是倾向于在私有服务器上托管应用程序，以确保数据的安全性和保密性。通过私有化部署，您可以完全掌控数据和通信，可以轻松地进行监视和管理，从而更好地保证数据安全和隐私。"
            )}
          </div>
        </div>
        <div className="arrow-right">
          <Down />
        </div>
        <div className="product-features">
          <div className="product-features-top">
            <div className="product-features-top-right">
              <img src={file2} className="file2" />
            </div>
            <div className="product-features-top-left">
              {t("我们的产品特色")}
              <div className="product-features-top-left-bg"></div>
            </div>
          </div>
          <div className="product-features-content">
            {t(
              "我们提供了详细的部署文档，使您能够轻松地将我们的 IM 工具部署在您自己的服务器上。我们还提供了技术支持，以确保您的部署顺利进行。"
            )}
          </div>
        </div>
        <div className="arrow-down">
          <div className="arrow-down-line"></div>
          <Down />
        </div>
        <div className="encipher-container">
          <div className="encipher-left">
            <div className="encipher-left-top">{t("多重加密算法")}</div>
            <div className="encipher-left-bottom">
              {t("多种加密方式共存，保障数据安全又兼容系统性能")}
            </div>
          </div>
          <div className="encipher-right">
            <img src={file3} className="file3" />
          </div>
        </div>
        <div className="encipher-container">
          <div className="encipher-right">
            <img src={file4} className="file4" />
          </div>
          <div className="encipher-left" style={{ textAlign: "right" }}>
            <div className="encipher-left-top">{t("全球节点竞速")}</div>
            <div className="encipher-left-bottom">
              {t("自动匹配最优线路，提供最佳用户体验")}
            </div>
          </div>
        </div>
        <div className="encipher-container">
          <div className="encipher-left">
            <div className="encipher-left-top">{t("团队模式")}</div>
            <div className="encipher-left-bottom">
              {t("提供团队邀请模式，分类管理渠道用户")}
            </div>
          </div>
          <div className="encipher-right">
            <img src={file5} className="file5" />
          </div>
        </div>
        <div className="encipher-container">
          <div className="encipher-right">
            <img src={file6} className="file6" />
          </div>
          <div className="encipher-left" style={{ textAlign: "right" }}>
            <div className="encipher-left-top">{t("自定义应用")}</div>
            <div className="encipher-left-bottom">
              {t("创建快捷应用入口，设置快速访问")}
            </div>
          </div>
        </div>
        <div className="arrow-down">
          <div className="arrow-down-line"></div>
          <Down />
        </div>
        <p className="bottom-title">
          {t("一个真正的私有化部署能给你带来什么")}
        </p>
        <div className="bottom-list-title">
          {list.map((item) => {
            return (
              <div className="bottom-item-title" key={item}>
                <div>
                  <Checked />
                </div>
                <p>{t(item)}</p>
              </div>
            );
          })}
        </div>
      </div>
      <div className="bottom-content-bottom">
        <div className="bottom-content-bg1">
          <Bottombg />
          <div className="bottom-content-center">
            <Icon />
            <p>AleIM</p>
            <div className="bottom-content">{t("我们才是最适合您的产品")}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
